// Catch-all 404 — shown for any undefined route. Marked noindex so Google
// drops soft-404 URLs from the index.
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { BookOpen } from "lucide-react";

const NAVY = "#1B2F5E";
const GOLD = "#C9A96E";

export default function NotFoundPage() {
  return (
    <div className="min-h-[60vh] topo-bg" data-testid="not-found-page">
      <Helmet>
        <title>Page Not Found · SummaryMaps Journal</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <main className="relative z-10 max-w-2xl mx-auto px-4 sm:px-6 pt-16 sm:pt-24 pb-24 text-center">
        <span
          className="inline-flex w-14 h-14 rounded-2xl items-center justify-center mb-8"
          style={{ background: `${GOLD}26`, color: GOLD }}
        >
          <BookOpen className="w-6 h-6" />
        </span>
        <div
          className="text-xs uppercase tracking-[0.22em] font-semibold mb-3"
          style={{ color: GOLD }}
        >
          404
        </div>
        <h1
          className="font-serif text-4xl sm:text-5xl font-semibold leading-tight"
          style={{ color: NAVY }}
        >
          Page Not Found
        </h1>
        <p className="mt-5 text-base md:text-lg" style={{ color: "#4A5568", lineHeight: 1.7 }}>
          The page you're looking for doesn't exist or may have been moved.
          Head back to the journal to keep reading.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center mt-9 px-7 py-3.5 rounded-full font-bold text-sm sm:text-base text-white transition-transform hover:scale-105"
          style={{ background: NAVY }}
          data-testid="not-found-home-link"
        >
          Back to the homepage
        </Link>
      </main>
    </div>
  );
}
